module.exports = __webpack_public_path__ + "img/11.6ce54f44.png";